// import highlight.js without any languages
import highlightjs from 'highlight.js/lib/highlight';

// separately require languages
highlightjs.registerLanguage('json', require('highlight.js/lib/languages/json'));
highlightjs.registerLanguage('xml', require('highlight.js/lib/languages/xml'));

export default highlightjs;
